module.exports = __webpack_public_path__ + "media/whoosh-2.deed7585.mp3";